import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { adminApiService } from "../../../services/adminApiService";

interface AdminRequestsState {
  requestsListData: any[];
  requestsListPagination: any;
  isLoadingList: boolean;
  error: string | null;
}

const initialState: AdminRequestsState = {
  requestsListData: [],
  requestsListPagination: null,
  isLoadingList: false,
  error: null,
};

export const fetchAdminRequests = createAsyncThunk(
  "adminRequests/fetchRequests",
  async (params: any, { rejectWithValue }) => {
    try {
      return await adminApiService.getRequests(params);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const adminRequestsSlice = createSlice({
  name: "adminRequests",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminRequests.pending, (state) => {
        state.isLoadingList = true;
        state.error = null;
      })
      .addCase(fetchAdminRequests.fulfilled, (state, action) => {
        state.isLoadingList = false;
        state.requestsListData = action.payload.data?.requests || [];
        state.requestsListPagination = action.payload.data?.pagination || null;
      })
      .addCase(fetchAdminRequests.rejected, (state, action) => {
        state.isLoadingList = false;
        state.error = action.payload as string;
      });
  },
});

export default adminRequestsSlice.reducer;